import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article';
};
export function Reveal({
  children,
  delay = 0,
  className = '',
  as = 'div'
}: Props) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] as typeof motion.div;
  if (reduce) {
    const Tag = as;
    return <Tag className={className} data-id="element-465" data-mp="5qm27s92l1y6">{children}</Tag>;
  }
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.55,
    delay,
    ease: [0.2, 0.8, 0.2, 1]
  }} data-id="element-466" data-mp="5p145snjr0vk">
      {children}
    </MotionTag>;
}